import React from "react";
import { useSelector } from "react-redux";
import type { EventOrganizer } from "@/services/api/user/events";
import SocietyAvatar from "./SocietyAvatar";
import StudentFollowButton from "./StudentFollowButton";

interface StudentOrganizerListProps {
  organizers: EventOrganizer[];
  onToggleFollow?: (organizerId: string, following: boolean) => void;
}

/**
 * Organizer (society) rows with follow toggles — the web equivalent of the RN
 * `OrganizerButton` row rendered at the top of every `EventBox`.
 */
const StudentOrganizerList: React.FC<StudentOrganizerListProps> = ({
  organizers,
  onToggleFollow,
}) => {
  const language = useSelector(
    (state: any) => state.setting?.language ?? "zh_hant",
  );

  if (!organizers || organizers.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
      {organizers.map((organizer) => {
        const name =
          (language === "zh_hant"
            ? organizer.name_zh_hant
            : organizer.name_en) ||
          organizer.name_en ||
          organizer.name_zh_hant ||
          "";
        const displayName =
          name.split("/")[0] || organizer.instagram_username || organizer.id;
        return (
          <div key={organizer.id} className="flex min-w-0 items-center gap-2">
            <SocietyAvatar
              icon={organizer.society_icon}
              name={displayName}
            />
            <span className="max-w-[180px] truncate text-sm text-gray-500">
              {displayName}
            </span>
            <StudentFollowButton
              organizerId={organizer.id}
              following={Boolean(organizer.following)}
              onChange={(following) => onToggleFollow?.(organizer.id, following)}
            />
          </div>
        );
      })}
    </div>
  );
};

export default StudentOrganizerList;
